app.service('permissions', function () {
	var $self, $permisions, $checkAll;

	function toggleAllPermisions(checkAllPermisions) {
		if (checkAllPermisions) {
			if ($('#permissions-list').length && $('#permissions-list').hasClass('old-mode')) {
				updateOldAgreements();
			}
			$permisions.prop('checked', true);
			$permisions.valid();
		} else {
			$permisions.prop('checked', false);
		}
	}
	function updateOldAgreements() {
		$('#current-permissions-message').addClass('loading');
		setTimeout(function () {
			$('#current-permissions-message').remove();
			$('#permissions-list').removeClass('old-mode');
			$('#permissions-displayed').val('true');
		}, 1000);
	}
	function setElements() {
		$self = $('#permissions');
		$permisions = $('.js-permission input:checkbox', $self);
		$checkAllPermissionsCheckbox = $('#check-all-permissions', $self);
	}
	function setEvents() {
		//Zaznacz wszystkie zgody
		$checkAllPermissionsCheckbox.on('click', function () {
			const permissionsStatus = getSelectedPermissionsState();
			const status = permissionsStatus === 'ALL_SELECTED' ? false : true; //jesli wszystkie zgody sa zaznaczone to je odznacz, w przeciwnym razie zaznacz wszystkie
			$checkAllPermissionsCheckbox.removeClass('partial-checked').prop('checked', status);
			toggleAllPermisions(status);
		});

		//wylacz checkbox zaznacz wszystkie
		$permisions.on('click', function () {
			const permissionsStatus = getSelectedPermissionsState();
			$checkAllPermissionsCheckbox.removeClass('partial-checked');
			switch (permissionsStatus) {
				case 'ALL_SELECTED':
					$checkAllPermissionsCheckbox.prop('checked', true);
					break;
				case 'SOME_SELECTED':
					$checkAllPermissionsCheckbox.prop('checked', true);
					$checkAllPermissionsCheckbox.addClass('partial-checked');
					break;
				default:
					$checkAllPermissionsCheckbox.prop('checked', false);
					break;
			}
		});

	}
	function checkIfAllCheckboxesSelected() {
		return $permisions.not(':checked').length === 0;
	}
	function getSelectedPermissionsState() {
		const allPermissions = $permisions.length;
		const checkedPermissions = $permisions.filter(':checked').length;
		if (checkedPermissions === allPermissions) {
			return 'ALL_SELECTED';
		} else if (checkedPermissions > 0 && checkedPermissions < allPermissions) {
			return 'SOME_SELECTED';
		} else {
			return 'NONE_SELECTED';
		}
	}

	function init() {
		setElements();
		setEvents();
	}

	return {
		init,
		updateOldAgreements
	};
});
